import { React, useState, useEffect } from 'react';
import styled from 'styled-components';

import { useTheme } from '../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../Styles/theme';
import { useLanguage } from '../../../../Context/LanguageContext';

import moment from 'moment';

import TotalModalWrapper from '../../../Share/Normal/TotalModalWrapper';

import { ReactComponent as ExitButtonSvg } from '../../../../image/ExitButtonImage.svg';
import WhiteTrashIcon from '../../../../image/WhiteTrashIcon.png';

export default function WeekClassDeleteModal(props) {
  const {
    deletedData,
    onClickExit,
    onClickOnlyOneDelete,
    onClickAllDelete
  } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();
  const [title, setTitle] = useState('');

  // 삭제 텍스트 정리 //
  useEffect(() => {
    if (deletedData === undefined || title !== '') return;

    let deletedDate = moment(deletedData.deletedDate);
    let dateText = t('classManage.deleteWeekTitle', { month: deletedDate.format('M'), week: getWeekNumber(deletedDate) });

    setTitle(dateText);
  }, [deletedData, title])

  // 몇주차인지 계산하기 //
  function getWeekNumber(date) {
    const standard = new Date(date);

    const currentDate = standard.getDate();
    const startOfMonth = new Date(standard.setDate(1));
    const weekDay = startOfMonth.getDay();

    return parseInt(((weekDay - 1) + currentDate) / 7) + 1;
  }

  // 영어 요일을 한글로 변환 //
  function getDayOfWeekInKorean() {
    if (!deletedData) return '';

    const dayMap = {
      'Sun': t('classManage.daySun'),
      'Mon': t('classManage.dayMon'),
      'Tue': t('classManage.dayTue'),
      'Wed': t('classManage.dayWed'),
      'Thu': t('classManage.dayThu'),
      'Fri': t('classManage.dayFri'),
      'Sat': t('classManage.daySat')
    };

    const dayKey = deletedData.changeApplyWeek?.replace(',', '');
    return dayMap[dayKey] || '';
  }

  // 지정한 주만 버튼에 마우스 호버링 시작 //
  function onMouseEnterOnlyOneButton() {
    let deletedDate = moment(deletedData.deletedDate);
    let dateText = t('classManage.deleteOnlyOne', { month: deletedDate.format('M'), week: getWeekNumber(deletedDate), day: getDayOfWeekInKorean() });

    setTitle(dateText);
  }

  // 지정한 주만 버튼에 마우스 호버링 끝 //
  function onMouseLeaveOnlyOneButton() {
    let deletedDate = moment(deletedData.deletedDate);
    let dateText = t('classManage.deleteWeekTitle', { month: deletedDate.format('M'), week: getWeekNumber(deletedDate) });

    setTitle(dateText);
  }

  // 영구삭제 버튼에 마우스 호버링 시작 //
  function onMouseEnterAllButton() {
    let deletedDate = moment(deletedData.deletedDate);
    let dateText = t('classManage.deleteAll', { month: deletedDate.format('M'), week: getWeekNumber(deletedDate), day: getDayOfWeekInKorean() });

    setTitle(dateText);
  }

  // 영구삭제 버튼에 마우스 호버링 끝 //
  function onMouseLeaveAllButton() {
    let deletedDate = moment(deletedData.deletedDate);
    let dateText = t('classManage.deleteWeekTitle', { month: deletedDate.format('M'), week: getWeekNumber(deletedDate) });

    setTitle(dateText);
  }

  return (
    <TotalModalWrapper>
      <ModalView>
        <RedTrashBoxWrapper>
          <EmptyButtonWrapper />
          <RedTrashBox>
            <TrashImage src={WhiteTrashIcon} />
          </RedTrashBox>
          <ExitButtonWrapper onClick={onClickExit}>
            <ExitImage />
          </ExitButtonWrapper>
        </RedTrashBoxWrapper>
        <BottomWrapper>
          <TotalWrapper>
            <Title>{title}</Title>
            <TextWrapper>
              <Explanation>{t('classManage.deleteWarning1')}</Explanation>
              <Explanation>{t('classManage.deleteWarning2')}</Explanation>
            </TextWrapper>
          </TotalWrapper>
          <ButtonWrapper>
            <OnlyOneDeleteButton
              onMouseEnter={onMouseEnterOnlyOneButton}
              onMouseLeave={onMouseLeaveOnlyOneButton}
              onClick={onClickOnlyOneDelete}>
              {t('classManage.deleteThisWeek')}
            </OnlyOneDeleteButton>
            <AllDeletetButton
              onMouseEnter={onMouseEnterAllButton}
              onMouseLeave={onMouseLeaveAllButton}
              onClick={onClickAllDelete}>
              {t('classManage.deleteAllWeeks')}
            </AllDeletetButton>
          </ButtonWrapper>
        </BottomWrapper>
      </ModalView>
    </TotalModalWrapper>
  )
}

const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 354px;
  height: 200px;

  border-radius: 15px;
  box-shadow: 0px 40px 50px rgba(0, 0, 0, 0.1);
  background-color: ${props => props.theme.subBackground};
`;

const BottomWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 100%;
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  margin-top: 12px;

  width: 90.33%;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;

  text-align: center;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 8px;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;

const RedTrashBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0px 12px 0px 12px;
  margin-top: -43px;

  width: calc(100% - 24px);
`;

const RedTrashBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  min-width: 86px;
  max-width: 86px;
  width: 86px;

  min-height: 86px;
  max-height: 86px;
  height: 86px;

  border-radius: 86px;
  background-color: #FF3131;
`;

const TrashImage = styled.img`
  width: 53px;
  height: 53px;
`;

const EmptyButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 12px;
  height: 12px;
`;

const ExitButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 36px;

  width: 12px;
  height: 12px;

  &:hover {
    cursor: pointer;
  }
`;

const ExitImage = styled(ExitButtonSvg)`
  flex-shrink: 0;
  width: 12px;
  height: 12px;

  & path {
    fill: ${props => props.theme.line};
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  min-height: 52px;

  overflow: hidden;

  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
`;

const OnlyOneDeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 50%;
  height: 100%;

  background-color: ${props => props.theme.buttonFill3};

  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.white};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.subKey};
  }
`;

const AllDeletetButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 50%;
  height: 100%;

  background-color: ${props => props.theme.buttonFill3};

  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.white};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.pointRed};
  }
`;
